<ng-template class="theme-modal" #sizeChart let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Bancos Participantes</h5>
      <button type="button" class="border-0 bg-transparent" 
              (click)="modal.dismiss('Cross click')" aria-label="Close"
              style="font-size: 1.8rem; line-height: 1; color: #333;">
        &times;
      </button>
    </div>
    <div class="modal-body text-center">
      <img src="assets/images/size-chart.jpg" alt="" class="img-fluid rounded shadow">
    </div>
  </div>
</ng-template>
